import { defineStore } from "pinia";
import axiosInstance from "@/config/axios";

export const useProductAdStore = defineStore("ProductAd", {
    state: () => {
        return {
            productAdInsights: [],
            productAdInsightsCategories: [],
            productAdInsightsCategoriesLoading: false,
            productAdInsightsCategoriesOrderBy: null,
            productAdInsightsCategoriesSortBy: null,
            productAdInsightsLoading: false,
            productAds: [],
            productAdsLoading: false,
        };
    },
    getters: {},
    actions: {
        async fetchProductAds({ shopId }) {
            return axiosInstance.get(`/v1/product-ad/${shopId}`).then((response) => {

                this.productAds = response.data;
            });
        },

        async updateCreateProductAd({ data, shopId }) {
            return axiosInstance.post(`/v1/product-ad/update-create/${shopId}`, data);
        },

        async disableEnableProductAds({ data, shopId }) {
            return axiosInstance.post(`/v1/product-ad/disable-enable/${shopId}`, data);
        },

        async getBrands({ shopId }) {
            return axiosInstance.get(`/v1/product-ad/brands/${shopId}`);
        },

        async getMaxCpc({ data, shopId }) {
            return axiosInstance.get(`/v1/product-ad/max-cpc/${shopId}`, {
                params: data,
            });
        },

        async fetchInsights({ data, shopId }) {
            return this.fetchInsightsPlot({ data, shopId }).then((response) => {
                if (response !== undefined) {
                    this.productAdInsights = response.data;
                }
            });
        },

        async fetchInsightsPlot({ shopId, data }) {
            return axiosInstance.get(`/v1/product-ad/insights/${shopId}`, {
                params: data,
            });
        },

        async fetchInsightsCategories({ data, shopId }) {
            return axiosInstance
                .get(`/v1/product-ad/insights-categories/${shopId}`, {
                    params: data,
                })
                .then((response) => {
                    this.productAdInsightsCategories = response.data;
                });
        },
    },
});
